import styled from 'styled-components';
import { tokens } from '../../../components/modal-form/tokens';

export const GradeAppLocatario = styled.div`
    display: flex;
    gap: 32px;
    align-items: flex-start;

    .celular { flex: none; display: flex; flex-direction: column; align-items: center; gap: 10px; min-width: 200px; }

    @media (max-width: 860px) {
        flex-direction: column-reverse;
        align-items: stretch;
        .celular { align-self: center; }
    }
`;

export const ColunaRoteiro = styled.div`
    flex: 1;
    min-width: 0;

    h1 { font-size: 1.3rem; font-weight: 600; color: ${tokens.textPrimary}; margin: 0 0 4px; }
    .sub { font-size: ${tokens.fontBase}; color: ${tokens.textMuted}; margin: 0 0 16px; line-height: 1.45; }

    .legenda { margin: 10px 0 20px; font-size: ${tokens.fontBase}; color: ${tokens.textSecondary}; line-height: 1.45; }
`;

export const RotuloCelular = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    border-radius: 8px;
    background: linear-gradient(90deg, #143C8F 0%, #335EDB 100%);
    color: #ffffff;
    font-size: ${tokens.fontSm};
    font-weight: 500;
    white-space: nowrap;
`;

export const Atalhos = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    button {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        border: 1px solid ${tokens.borderDefault};
        border-radius: 999px;
        background: ${tokens.bgWhite};
        padding: 6px 14px 6px 6px;
        font: inherit;
        font-size: ${tokens.fontSm};
        font-weight: 600;
        color: ${tokens.textSecondary};
        cursor: pointer;
        transition: background 0.2s, color 0.2s, border-color 0.2s;
    }

    button span {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #e9ecef;
        font-size: ${tokens.fontXs};
    }

    button.ativo {
        border-color: transparent;
        background: linear-gradient(90deg, #143C8F 0%, #335EDB 100%);
        color: #ffffff;
        span { background: rgba(255, 255, 255, 0.25); }
    }
`;

export const Entrega = styled.div`
    border-top: 1px solid ${tokens.borderLight};
    padding-top: 14px;

    h3 { font-size: ${tokens.fontBase}; font-weight: 600; color: ${tokens.textPrimary}; margin: 0 0 10px; }
    /* QR codes e acesso lado a lado (empilha só quando não cabe), para o Continuar caber na tela. */
    .linha { display: flex; flex-wrap: wrap; gap: 14px; align-items: center; }
    .linha > :last-child { flex: 1 1 220px; min-width: 0; }
`;
